var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.6vw",
    height: "1.6vw",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.667 5.33301H9.33366C7.8609 5.33301 6.66699 6.52692 6.66699 7.99968V25.333C6.66699 26.8058 7.8609 27.9997 9.33366 27.9997H22.667C24.1398 27.9997 25.3337 26.8058 25.3337 25.333V7.99968C25.3337 6.52692 24.1398 5.33301 22.667 5.33301Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H20M12 17.3333H20M12 22.6667H17.3333",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.69aba6a5ccbac7376fd4733dd16e9a5a.svg";
export { ForwardRef as ReactComponent };